import React from 'react';

const InfoBubble = ({ active, cta_text, handleClick, ref }) => {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={`Hotspot for ${cta_text}`}
      className={`infoBubble ${active ? 'infoBubble--active' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        if (handleClick) {
          handleClick();
        }
      }}
    >
      <span>i</span>
    </button>
  );
};

export default InfoBubble;
